module.exports = __webpack_public_path__ + "media/online_university/edu-online-universities-hero-a8afe812.jpg";